import { render } from "./NotasCreditoView.vue?vue&type=template&id=32227d38&scoped=true"
import script from "./NotasCreditoView.vue?vue&type=script&lang=js"
export * from "./NotasCreditoView.vue?vue&type=script&lang=js"

import "./NotasCreditoView.vue?vue&type=style&index=0&id=32227d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32227d38"]])

export default __exports__